import { render, staticRenderFns } from "./profile-picture.vue?vue&type=template&id=71b442c7"
import script from "./profile-picture.vue?vue&type=script&lang=js"
export * from "./profile-picture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports